var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4594_7890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.088 69.696C99.7049 68.8936 97.9066 68.8936 96.3851 69.696L85.5958 75.8478L78.2647 79.8599L67.4755 86.0118C66.0922 86.8141 64.294 86.8141 62.7724 86.0118L54.1963 81.1973C52.8131 80.3949 51.8449 78.9237 51.8449 77.3188V67.8236C51.8449 66.2189 52.6748 64.7477 54.1963 63.9453L62.6341 59.2645C64.0173 58.4621 65.8155 58.4621 67.3372 59.2645L75.7748 63.9453C77.1581 64.7477 78.1264 66.2189 78.1264 67.8236V73.9755L85.4575 69.8296V63.6778C85.4575 62.073 84.6276 60.6019 83.106 59.7995L67.4755 50.9729C66.0922 50.1705 64.294 50.1705 62.7724 50.9729L46.8652 59.7995C45.3436 60.6019 44.5137 62.073 44.5137 63.6778V81.4647C44.5137 83.0695 45.3436 84.5406 46.8652 85.343L62.7724 94.1696C64.1557 94.9721 65.9539 94.9721 67.4755 94.1696L78.2647 88.1515L85.5958 84.0056L96.3851 77.9876C97.7683 77.1852 99.5665 77.1852 101.088 77.9876L109.526 82.6683C110.909 83.4708 111.877 84.9418 111.877 86.5467V96.0419C111.877 97.6468 111.047 99.1178 109.526 99.9202L101.088 104.735C99.7049 105.537 97.9066 105.537 96.3851 104.735L87.9473 100.054C86.5641 99.2516 85.5958 97.7805 85.5958 96.1757V90.0238L78.2647 94.1696V100.321C78.2647 101.926 79.0946 103.397 80.6162 104.2L96.5234 113.026C97.9066 113.829 99.7049 113.829 101.226 113.026L117.134 104.2C118.517 103.397 119.485 101.926 119.485 100.321V82.5346C119.485 80.9297 118.655 79.4587 117.134 78.6562L101.088 69.696Z",
    fill: "url(#paint0_linear_4594_7890)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4594_7890",
    x: 36.5137,
    y: 46.3711,
    width: 90.9707,
    height: 79.2573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.494118 0 0 0 0 0.243137 0 0 0 0 0.917647 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4594_7890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4594_7890",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4594_7890",
    x1: 81.9994,
    y1: 50.3711,
    x2: 81.9994,
    y2: 113.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8247E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C15FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.9a289404ea9590ad1e1de795bfd1cbb0.svg";
export { ForwardRef as ReactComponent };